<!-- @if (!sendObj) { -->
<div style="padding-block: 20px; margin-inline: 20px">
	<app-gen-file-input
		#fileInput
		fileType="file"
		title_ph_lang="choose_invoice"
		(changeEvent)="uplFile($event)"
		avoidEmpty
	/>
</div>
<!-- } -->
@if (isUploading) {
	<div
		class="d-flex justify-content-center my-3"
		style="font-size: 30px"
		spinner
	></div>
}

@if (sendObj) {
	<div
		class="d-flex flex-column flex-lg-row gap-3"
		style="padding-block: 20px"
	>
		<div
			class="flex-grow-1 mx-auto"
			style="max-width: min(100%, 450px)"
		>
			<img
				[src]="getUrl()"
				style="max-width: inherit"
				class="scan-expense-img"
			/>
		</div>
		<div class="d-grid gap-2">
			<div>
				<label>{{ "description" | langVal }}</label>
				<app-gen-input
					[actualObj]="sendObj"
					fieldName="description"
					[errors]="errors"
					(keyupEvent)="validateEntireForm()"
				/>
			</div>
			<div>
				<label>{{ "expensetype_id" | langVal }}</label>
				<app-gen-autocomplete
					#expensetypeInput
					[fuzzySearchableClasses]="['expensetypes']"
					[actualObj]="sendObj"
					fieldName="expensetype_id"
					[error]="$safeNavigationMigration(errors?.expensetype_id)"
					(keyUp)="handleKeyUp($event, 'expensetype_id')"
					(chosenEvent)="validateEntireForm()"
					hasPlus
					plusLang="add_expnsetype"
					(plusClick)="openAddExpensetypeModal()"
				/>
			</div>

			<div>
				<label>{{ "supplier_id" | langVal }}</label>
				<app-gen-autocomplete
					#supplierInput
					[fuzzySearchableClasses]="['suppliers']"
					[actualObj]="sendObj"
					fieldName="supplier_id"
					[error]="$safeNavigationMigration(errors?.supplier_id)"
					(keyUp)="handleKeyUp($event, 'supplier_id')"
					(chosenEvent)="handleSupplierChanged()"
					hasPlus
					plusLang="add_supplier"
					(plusClick)="openAddSupplierModal()"
				/>
				@if (!sendObj.supplier_id) {
					<p class="error">{{ "supplier_should_be_added" | langVal }}</p>
				}
			</div>

			<div>
				<label>{{ "supplier_invoice" | langVal }}</label>
				<app-gen-input
					isNumber
					[actualObj]="sendObj"
					fieldName="supplier_invoice"
					[errors]="errors"
					(keyupEvent)="validateEntireForm()"
				/>
			</div>
			<div>
				<label>{{ "israel_invoice" | langVal }}</label>
				<app-gen-input
					isNumber
					[actualObj]="sendObj"
					fieldName="israel_invoice"
					[errors]="errors"
					(keyupEvent)="validateEntireForm()"
				/>
			</div>
			<div>
				<label>{{ "date" | langVal }}</label>
				<app-date-picker
					[actualObj]="sendObj"
					fieldName="date"
					[errors]="errors"
					(changeEvent)="validateEntireForm()"
				/>
			</div>
			<div class="d-flex justify-content-between">
				<div class="colstat-price">
					<label>{{ "sum" | langVal }}</label>
					<app-gen-input
						isNumber
						[actualObj]="sendObj"
						fieldName="sum"
						[errors]="errors"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
				<div>
					<label>{{ "withvat" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="sendObj"
						fieldName="withvat"
						optionsListName="withvatOpts"
						(changeEvent)="validateEntireForm()"
					/>
				</div>
			</div>
		</div>
	</div>
}
<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	@if (sendObj) {
		<app-btn-ext
			text="add"
			[disabled]="!isFormSubmittable"
			(clickEv)="submit()"
			[isSpin]="isSaving"
		/>
	}
</div>
@switch (modalProps?.name) {
	@case ("add-expensetype") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="expensetypes"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; $event && chooseExpensetype($event)"
				tableName="expensetypes"
				[fuzzyName]="modalProps.fuzzyName"
			/>
		</app-modal-wrap>
	}
	@case ("add-supplier") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="suppliers"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; $event && chooseSupplier($event)"
				tableName="suppliers"
				[fuzzyName]="modalProps.fuzzyName"
			/>
		</app-modal-wrap>
	}
}
